import generalSection from "../_section/section.class";
import {adminForm11Upload, userForm11Upload} from "./upload";
import DataForm from "./DataForm";
import dayjs from "dayjs";
import problem from "../_section/section-problem.class";

export class userForm11Section extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userForm11Upload);
        // Add missing date error

    }
}

export class adminForm11Section extends userForm11Section {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminForm11Upload);
        this.DataForm = DataForm
        this.sortByDateProp('year')
        this.setProblems(this.getProblems())
    }
    numberOfForm11Needed = () => {
        if (['ics','nua'].includes(this.mortgage.activeSubmission?.lenderCode)){
            return 2
        }
        return 3
    }


    getProblems() {
        const problems = this.problemsList.universalVerifiedUploadProblems();
        if (!problems.length) {
            const noRequired = this.numberOfForm11Needed() // 2 or 3 depending on lender
            // is today passed 1 July ?
            const firstJuly = dayjs().month(6).date(1)

            // dont need last year form 11 but number required stays the same, so reduce by 1 and add missing

            const thisYear = Number(dayjs().format("YYYY"))
            const useYear = dayjs().isBefore(firstJuly) ? thisYear -1 : thisYear
            const yearsRequired = Array.from({length: noRequired}, (_, i) => (useYear - (i + 1)).toString())
            const yearsHave = this.uploads.filter(u => u.isActive && u.isVerifiable && u.allValuesAnswered).map(u => u.values.year)

            const missingFromRequired = yearsRequired.filter(item => !yearsHave.includes(item))
            if (missingFromRequired.length > 0) {
                problems.push(new problem({
                    type: 'BUNDLE',
                    title: 'Missing Form 11',
                    reason: 'Missing Form 11 ',
                    message: `Missing Form 11 for ${missingFromRequired.join(', ')}`
                }))
            }

        }
        return problems;
    }
}